import React from 'react';
import { Pagination as BootstrapPagination, PaginationItem, PaginationLink } from 'reactstrap';

export default function Pagination(props) {
  const { currentStart, currentEnd, totalCount, hasPrev, hasNext, prev, next } = props;
  return (
    <div className="d-flex align-items-center gap-2">
      <div className="small text-muted">
        {currentStart} - {currentEnd} / {isFinite(totalCount) ? totalCount : '多数'}
      </div>
      <BootstrapPagination listClassName="m-0">
        <PaginationItem disabled={!hasPrev}>
          <PaginationLink onClick={prev}>
            <span className="fas fa-angle-left" />
          </PaginationLink>
        </PaginationItem>
        <PaginationItem disabled={!hasNext}>
          <PaginationLink onClick={next}>
            <span className="fas fa-angle-right" />
          </PaginationLink>
        </PaginationItem>
      </BootstrapPagination>
    </div>
  );
};
